import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, FormControl, Nav, Dropdown, Button, Badge } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import { FiSearch } from "react-icons/fi";
import { BsBellFill } from "react-icons/bs";
import logo from "../assets/images/logo-fanfub.png";
import { useAuth } from "../../src/context/AuthContext";
import profileImage from "../assets/images/avatar_woman1.svg";
import { GrMenu, GrClose } from "react-icons/gr";
import { FaUser } from "react-icons/fa";
import { RiLogoutBoxRLine } from "react-icons/ri";

function AppNavbar({ isCollapsed, setIsCollapsed }) {

  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const [activeDropdown, setActiveDropdown] = useState(null);



  useEffect(() => {
    const updateScreenSize = () => {
      const mobileView = window.innerWidth <= 575;
      setIsMobile(mobileView);

      // ✅ Ensure sidebar is closed when loading on mobile
      if (mobileView) {
        setIsCollapsed(false); // Close sidebar initially on mobile
      }
    };

    updateScreenSize(); // Run on mount
    window.addEventListener("resize", updateScreenSize);

    return () => window.removeEventListener("resize", updateScreenSize);
  }, [setIsCollapsed]);

  useEffect(() => {
    if (isCollapsed) {
      setActiveDropdown(null); // ✅ Close all dropdowns when sidebar menu is closed
    }
  }, [isCollapsed]);

  const [notifications] = useState([
    { id: 1, text: "New comment on your post", link: "/notifications" },
    { id: 2, text: "Your profile was viewed", link: "/profile" },
    { id: 3, text: "New follower request", link: "/followers" },
    { id: 4, text: "New message received", link: "/messages" },
    { id: 5, text: "Someone liked your post", link: "/likes" },
    { id: 6, text: "Event reminder: Webinar at 3 PM", link: "/events" },
  ]);

  // Handle logout and navigate to home
  const handleLogout = () => {
    logout();  // Perform logout
    navigate("/"); // Redirect to home page
  };

  // Reusable search input
  const searchInput = (
    <div className="search-container d-flex align-items-center">
      <FiSearch className="search-icon" />
      <FormControl
        type="search"
        placeholder="Search post, people or club"
        className="search-input"
      />
    </div>
  );


  return (
    <Navbar expand="lg" className="app-navbar">
      <div className="container-fluid container-xxl app-navbar-container">
        <div className="logo-container">
          <Navbar.Brand as={Link} to="/">
            <img src={logo} alt="Company logo" className="image-full" />
          </Navbar.Brand>
        </div>


        <div className={`nav-content-container ${location.pathname === "/help" ? "no-search-page" : ""}`}>
          {/* <Navbar.Toggle aria-controls="navbar-nav" /> */}
          {/* <Navbar.Collapse id="navbar-nav"> */}
          {/* Hide search bar if the page is Help */}
          {location.pathname !== "/help" && (
            isMobile === true ?
              // <Dropdown className="search-dropdown">
              //   <Dropdown.Toggle variant="link" className="p-0">
              //     <FiSearch className="search-icon" />
              //   </Dropdown.Toggle>
              //   <Dropdown.Menu>
              //     {searchInput}
              //   </Dropdown.Menu>
              // </Dropdown>
              // : searchInput

              <Dropdown className="search-dropdown" show={activeDropdown === "search"} onToggle={() => {
                setActiveDropdown(activeDropdown === "search" ? null : "search");
                setIsCollapsed(false); // ✅ Close navigation when opening search
              }}>
                <Dropdown.Toggle variant="link" className="p-0" onClick={(e) => {
                  e.stopPropagation();
                  setActiveDropdown(activeDropdown === "search" ? null : "search");
                  setIsCollapsed(false); // ✅ Close navigation when opening search
                }}>
                  <FiSearch className="search-icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                  {searchInput}
                </Dropdown.Menu>
              </Dropdown>
              : searchInput
          )}

          <div className="navbar-right">
            <Nav className="profile-dropdown-menu d-flex align-items-center">
              {isAuthenticated && (
                <>
                  <Dropdown align="end" className="notification-dropdown" show={activeDropdown === "notifications"} onToggle={() => {
                    setActiveDropdown(activeDropdown === "notifications" ? null : "notifications");
                    setIsCollapsed(false); // ✅ Close navigation when opening notifications
                  }}>
                    <Dropdown.Toggle as="div" className="notification-toggle" onClick={(e) => {
                      e.stopPropagation();
                      setActiveDropdown(activeDropdown === "notifications" ? null : "notifications");
                      setIsCollapsed(false); // ✅ Close navigation when opening notifications
                    }}>
                      <BsBellFill className="notification-bell" />
                      {notifications.length > 0 && (
                        <Badge bg="danger" className="notification-badge">
                          {notifications.length > 5 ? "5" : notifications.length}
                        </Badge>
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="notification-menu" onClick={(e) => e.stopPropagation()}>
                      {notifications.slice(0, 5).map((notification) => (
                        <Dropdown.Item key={notification.id} as={Link} to={notification.link} className="notification-item">
                          {notification.text}
                        </Dropdown.Item>
                      ))}
                      <Dropdown.Divider />
                      <Dropdown.Item as={Link} to="/notifications" className="view-all">
                        View All Notifications
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown align="end" show={activeDropdown === "profile"} onToggle={() => {
                    setActiveDropdown(activeDropdown === "profile" ? null : "profile");
                    setIsCollapsed(false); // ✅ Close navigation when opening profile dropdown
                  }}>
                    <Dropdown.Toggle as={Button} variant="light" className="border-0 bg-transparent" onClick={(e) => {
                      e.stopPropagation();
                      setActiveDropdown(activeDropdown === "profile" ? null : "profile");
                      setIsCollapsed(false); // ✅ Close navigation when opening profile dropdown
                    }}>
                      <img
                        src={profileImage}
                        alt="Profile"
                        className="rounded-circle"
                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                      <Dropdown.Item as={Link} to="/profile"><FaUser /> My Profile</Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={handleLogout}><RiLogoutBoxRLine /> Logout</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </Nav>
            {/* </Navbar.Collapse> */}

            <Button
              variant="link"
              className="p-0 collapsed-btn"
              onClick={(e) => {
                e.stopPropagation();
                setActiveDropdown(null); // ✅ Close all dropdowns
                // setIsCollapsed((prev) => !prev); // ✅ Toggle sidebar menu
                setIsCollapsed(!isCollapsed)
              }}
            >
              {isCollapsed ? <GrClose /> : <GrMenu />}
            </Button>
          </div>
        </div>
      </div>
    </Navbar>
  );
}

export default AppNavbar;
